import { HTTP, HTTP_FORM_DATA } from "@/common/utils/http";

export const SignUpService = {

    signUp(form) {
        const formData = new FormData();
        Object.keys(form).forEach(key => {
            formData.append(key, form[key]);
        });
        const headers = {'Content-Type': 'multipart/form-data'};
        return HTTP.post('/no-auth/schools/register', formData, {headers});
    },

    checkEmail(email) {
        const headers = {'Content-Type': 'plain/text'};
        return HTTP.post('/no-auth/schools/check-email', email, { headers });
    },

    verifyEmail(form) {
        return HTTP.patch('/no-auth/schools/verify-email', form);
    },

    requestVerifyEmail(email) {
        return HTTP.post('/no-auth/schools/request-verify-email-token', { email });
    }
};


// WEBPACK FOOTER //
// ./src/common/services/sign-up.service.js